import type { SpectralRanges } from '@ledium/types';

type SpectralRangesMap = { pfd: SpectralRanges; irradiance: SpectralRanges };

export const calculateRelativeSpectrogramRanges = (spectrogram: SpectralRangesMap, intensityRatio: number): SpectralRangesMap => {
    const ranges = {} as SpectralRangesMap;
    for (const unit of ['pfd', 'irradiance'] as const) {
        ranges[unit] = {} as SpectralRanges;
        for (const category of Object.keys(spectrogram[unit]) as (keyof SpectralRanges)[]) {
            ranges[unit][category] = Math.round(spectrogram[unit][category] * intensityRatio);
        }
    }
    return ranges;
};
